// // @ts-nocheck
// import { useTranslation } from 'react-i18next';
// import Select from 'react-select';
// import 'react-datepicker/dist/react-datepicker.css';
// import Form from 'react-bootstrap/Form';
// import useLookupTitle from '@hooks/Lookups/use-Lookup-Title';
// import useLookupSex from '@hooks/Lookups/use-Lookup-Sex';
// import useLookupMarStatus from '@hooks/Lookups/use-Lookup-MarStatus';
// import useLookupNationality from '@hooks/Lookups/use-Lookup-Nationality';
// import PersonImage from '@components/PersonImage/PersonImage';
// import useGetBanks from '@hooks/Lookups/use-get-Banks';
// import useGetRotationPlan from '@hooks/HR/use-get-RotationPlan';
// import useLookupReligions from '@hooks/Lookups/use-Lookup-Religions';

// const EditEmployees = ({ formik }) => {
//   const { t, i18n } = useTranslation();
//   const { TITLE } = useLookupTitle();
//   const { SEX } = useLookupSex();
//   const { MAR_STATUS } = useLookupMarStatus();
//   const { dataNATIONALITY } = useLookupNationality();
//   const { Banks } = useGetBanks();
//   const { RotationPlanList } = useGetRotationPlan();
//   const { RELIGIONS } = useLookupReligions();

//   const handleImageUpload = (event) => {
//     formik.setFieldValue('Person_Img', event.currentTarget.files[0]);
//     formik.setFieldValue('Is_Update_IMG', true);
//   };

//   return (
//     <>
//       <div className="row">
//         <div className="col-xl-9">
//           <div className="row">
//             <div className="col-xl-2">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('EmployeeNumber')}</label>
//                 <Form.Control
//                   // readOnly
//                   className="form-control fw-bold text-theme"
//                   type="text"
//                   autoComplete="off"
//                   name="employeeNumber"
//                   onChange={formik.handleChange}
//                   value={formik.values.employeeNumber || ''}
//                   isInvalid={formik.touched.employeeNumber && formik.errors.employeeNumber}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.employeeNumber}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-2">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('title')}</label>
//                 <Form.Select
//                   className="form-select"
//                   name="TITLE"
//                   onChange={formik.handleChange}
//                   value={formik.values.TITLE || ''}
//                   isInvalid={formik.touched.TITLE && formik.errors.TITLE}>
//                   <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {TITLE?.map((item, idx) =>
//                     item.list?.map((list) => (
//                       <option key={++idx} value={list.lookupCode}>
//                         {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                       </option>
//                     ))
//                   )}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{formik.errors.TITLE}</Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-4">
//               <div className="form-group mb-3  ">
//                 <label className="form-label">{t('LocalName')}</label>

//                 <Form.Control
//                   type="text"
//                   autoComplete="off"
//                   className="form-control"
//                   name="NAME2"
//                   onChange={formik.handleChange}
//                   value={formik.values.NAME2 || ''}
//                   isInvalid={formik.touched.NAME2 && formik.errors.NAME2}
//                 />
//                 <Form.Control.Feedback type="invalid">{formik.errors.NAME2}</Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-4">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('GlobalName')}</label>
//                 <Form.Control
//                   style={{ direction: 'ltr' }}
//                   type="text"
//                   autoComplete="off"
//                   className="form-control"
//                   name="NAME"
//                   onChange={formik.handleChange}
//                   value={formik.values.NAME || ''}
//                   isInvalid={formik.touched.NAME && formik.errors.NAME}
//                 />
//                 <Form.Control.Feedback type="invalid">{formik.errors.NAME}</Form.Control.Feedback>
//               </div>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('Gender')}</label>
//                 <Form.Select
//                   className="form-select"
//                   name="GENDER"
//                   onChange={formik.handleChange}
//                   value={formik.values.GENDER || ''}
//                   isInvalid={formik.touched.GENDER && formik.errors.GENDER}>
//                   {SEX?.map((item, idx) =>
//                     item.list?.map((list) => (
//                       <option key={++idx} value={list.lookupCode}>
//                         {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                       </option>
//                     ))
//                   )}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{formik.errors.GENDER}</Form.Control.Feedback>
//               </div>
//             </div>
//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('Identity')}</label>
//                 <Form.Control
//                   className="form-control"
//                   type="text"
//                   autoComplete="off"
//                   placeholder="الهوية"
//                   name="NATIONAL_IDENTIFIER"
//                   onChange={formik.handleChange}
//                   value={formik.values.NATIONAL_IDENTIFIER || ''}
//                   isInvalid={
//                     formik.touched.NATIONAL_IDENTIFIER && formik.errors.NATIONAL_IDENTIFIER
//                   }
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.NATIONAL_IDENTIFIER}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('Email')}</label>
//                 <Form.Control
//                   className="form-control"
//                   type="text"
//                   autoComplete="off"
//                   name="emailAddress"
//                   onChange={formik.handleChange}
//                   value={formik.values.emailAddress || ''}
//                   isInvalid={formik.touched.emailAddress && formik.errors.emailAddress}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.emailAddress}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('MobileNumber')}</label>
//                 <Form.Control
//                   className="form-control"
//                   type="text"
//                   autoComplete="off"
//                   name="mobile"
//                   onChange={formik.handleChange}
//                   value={formik.values.mobile || ''}
//                   isInvalid={formik.touched.mobile && formik.errors.mobile}
//                 />
//                 <Form.Control.Feedback type="invalid">{formik.errors.mobile}</Form.Control.Feedback>
//               </div>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('Marital Status')}</label>
//                 <Form.Select
//                   className="form-select"
//                   name="MARITAL_STATUS"
//                   onChange={formik.handleChange}
//                   value={formik.values.MARITAL_STATUS || ''}
//                   isInvalid={formik.touched.MARITAL_STATUS && formik.errors.MARITAL_STATUS}>
//                   <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {MAR_STATUS?.map((item, idx) =>
//                     item.list?.map((list) => (
//                       <option key={++idx} value={list.lookupCode}>
//                         {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                       </option>
//                     ))
//                   )}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.MARITAL_STATUS}
//                 </Form.Control.Feedback>
//               </div>
//             </div>
//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('Religion')}</label>
//                 <Form.Select
//                   className="form-select"
//                   name="Religion"
//                   onChange={formik.handleChange}
//                   value={formik.values.Religion || ''}
//                   isInvalid={formik.touched.Religion && formik.errors.Religion}>
//                   <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {RELIGIONS?.map((item, idx) =>
//                     item.list?.map((list) => (
//                       <option key={++idx} value={list.lookupCode}>
//                         {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                       </option>
//                     ))
//                   )}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.Religion}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('Nationality')}</label>
//                 <Select
//                   classNamePrefix="react-select"
//                   isRtl
//                   isSearchable={true}
//                   required
//                   options={dataNATIONALITY}
//                   onChange={(option) => formik.setFieldValue('NATIONALITY', option.value)}
//                   value={dataNATIONALITY?.find((f) => f?.value === formik?.values?.NATIONALITY)}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 />

//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.NATIONALITY}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('HiringDate')}</label>
//                 <input
//                   type="date"
//                   id="START_DATE"
//                   className="form-control"
//                   name="START_DATE"
//                   onChange={formik.handleChange}
//                   value={formik.values.START_DATE || ''}></input>
//                 <div>{formik.errors.START_DATE}</div>
//               </div>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('DateofBirth')}</label>
//                 <input
//                   type="date"
//                   id="birthdaytime"
//                   className="form-control"
//                   name="DATE_OF_BIRTH"
//                   onChange={formik.handleChange}
//                   value={formik.values.DATE_OF_BIRTH || ''}></input>
//                 <div className='small text-danger'>{formik.errors.DATE_OF_BIRTH}</div>
//               </div>
//             </div>
//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('BirthCountry')}</label>

//                 <Select
//                   classNamePrefix="react-select"
//                   isRtl
//                   isSearchable={true}
//                   // required
//                   options={dataNATIONALITY}
//                   onChange={(option) => formik.setFieldValue('COUNTRY_OF_BIRTH', option.value)}
//                   value={dataNATIONALITY?.find((f) => f.value === formik.values.COUNTRY_OF_BIRTH)}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 />

//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.COUNTRY_OF_BIRTH}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('CityOfbirth')}</label>
//                 <Form.Control
//                   type="text"
//                   autoComplete="off"
//                   className="form-control"
//                   name="TOWN_OF_BIRTH"
//                   onChange={formik.handleChange}
//                   value={formik.values.TOWN_OF_BIRTH || ''}
//                   isInvalid={formik.touched.TOWN_OF_BIRTH && formik.errors.TOWN_OF_BIRTH}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.TOWN_OF_BIRTH}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-3">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('AnnualLeave')}</label>
//                 <Form.Select
//                   className="form-select"
//                   name="AnnualLeave"
//                   onChange={formik.handleChange}
//                   value={formik.values.AnnualLeave || ''}
//                   isInvalid={formik.touched.AnnualLeave && formik.errors.AnnualLeave}>
//                   <option value="0" key={null}>
//                     {i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                   </option>
//                   <option value="30"> 30 </option>
//                   <option value="21"> 21 </option>
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.AnnualLeave}
//                 </Form.Control.Feedback>
//               </div>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-xl-4">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('RotationPlan')}</label>
//                 <Form.Select
//                   className="form-select"
//                   name="RotationPlanId"
//                   onChange={formik.handleChange}
//                   value={formik.values.RotationPlanId || ''}
//                   isInvalid={formik.touched.RotationPlanId && formik.errors.RotationPlanId}>
//                   <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {RotationPlanList &&
//                     RotationPlanList?.map((item, idx) => (
//                       <option key={++idx} value={item.id}>
//                         {i18n.language === 'ar' ? item.name2 : item.name}
//                       </option>
//                     ))}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.RotationPlanId}
//                 </Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-4">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('NameOfTheBank')}</label>
//                 <Form.Select
//                   className="form-select"
//                   name="BankId"
//                   onChange={formik.handleChange}
//                   value={formik.values.BankId || ''}
//                   isInvalid={formik.touched.BankId && formik.errors.BankId}>
//                   <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {Banks &&
//                     Banks?.map((item, idx) => (
//                       <option key={++idx} value={item.id}>
//                         {i18n.language === 'ar' ? item.name2 : item.name}
//                       </option>
//                     ))}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{formik.errors.BankId}</Form.Control.Feedback>
//               </div>
//             </div>

//             <div className="col-xl-4">
//               <label className="form-label">IBAN</label>
//               <div className="input-group flex-nowrap">
//                 <Form.Control
//                   type="text"
//                   autoComplete="off"
//                   style={{ direction: 'ltr' }}
//                   className="form-control"
//                   name="IBan"
//                   onChange={formik.handleChange}
//                   value={formik.values.IBan || ''}
//                   isInvalid={formik.touched.IBan && formik.errors.IBan}
//                 />
//                 <Form.Control.Feedback type="invalid">{formik.errors.IBan}</Form.Control.Feedback>
//                 {/* <span className="input-group-text">SA</span> */}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="col-xl-3">
//           <div className="row">
//             <div className="col-xl-12">
//               <div className="form-group mb-3">
//                 <label className="form-label">{t('ChoosePhoto')} </label>
//                 <Form.Control
//                   type="file"
//                   className="form-control"
//                   placeholder=" أختر صورة"
//                   name="Person_Img"
//                   accept="image/*"
//                   onChange={(e) => handleImageUpload(e)}
//                   // isInvalid={!!formik.errors.persoN_IMG}
//                 />
//                 <Form.Control.Feedback type="invalid">
//                   {formik.errors.Person_Img}
//                 </Form.Control.Feedback>
//               </div>
//             </div>
//           </div>

//           {/* <div className=" bg-inverse bg-opacity-10 rounded-4 p-3 mb-3">  */}
//           <div className="col-xl-12 bg-inverse bg-opacity-5 rounded-4 p-2 mb-3 h-75">
//             {/* <Card> */}
//             {/* <CardBody> */}
//             {formik.values.Person_Img && <PersonImage file={formik.values.Person_Img} />}
//             {/* </CardBody> */}
//             {/* </Card> */}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EditEmployees;

// @ts-nocheck
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import useLookupTitle from '@hooks/Lookups/use-Lookup-Title';
import useLookupSex from '@hooks/Lookups/use-Lookup-Sex';
import useLookupMarStatus from '@hooks/Lookups/use-Lookup-MarStatus';
import useLookupNationality from '@hooks/Lookups/use-Lookup-Nationality';
import PersonImage from '@components/PersonImage/PersonImage';
import useGetBanks from '@hooks/Lookups/use-get-Banks';
import useGetRotationPlan from '@hooks/HR/use-get-RotationPlan';
import useLookupReligions from '@hooks/Lookups/use-Lookup-Religions';
import { useState, useMemo } from 'react';
import { Card, CardBody, CardHeader } from '@components/card/card';

// const EditEmployees = ({ formik }) => {
//   const { t, i18n } = useTranslation();
//   const { TITLE } = useLookupTitle();
//   const { SEX } = useLookupSex();
//   const { MAR_STATUS } = useLookupMarStatus();
//   const { dataNATIONALITY } = useLookupNationality();
//   const { Banks } = useGetBanks();
//   const { RotationPlanList } = useGetRotationPlan();
//   const { RELIGIONS } = useLookupReligions();

//   const [imagePreview, setImagePreview] = useState(null);

//   // تحسين الأداء باستخدام useMemo
//   const titleOptions = useMemo(() => TITLE?.flatMap(item => item.list || []) || [], [TITLE]);

//   const genderOptions = useMemo(() => SEX?.flatMap(item => item.list || []) || [], [SEX]);

//   const maritalOptions = useMemo(() => MAR_STATUS?.flatMap(item => item.list || []) || [], [MAR_STATUS]);

//   const religionOptions = useMemo(() => RELIGIONS?.flatMap(item => item.list || []) || [], [RELIGIONS]);

//   const handleImageUpload = event => {
//     const file = event.currentTarget.files[0];
//     if (file) {
//       // التحقق من حجم الصورة
//       if (file.size > 5 * 1024 * 1024) {
//         alert(t('ImageSizeError'));
//         event.target.value = '';
//         return;
//       }

//       // التحقق من نوع الملف
//       const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
//       if (!allowedTypes.includes(file.type)) {
//         alert(t('ImageTypeError'));
//         event.target.value = '';
//         return;
//       }

//       // إنشاء معاينة للصورة
//       const reader = new FileReader();
//       reader.onload = e => {
//         setImagePreview(e.target.result);
//       };
//       reader.readAsDataURL(file);

//       formik.setFieldValue('Person_Img', file);
//       formik.setFieldValue('Is_Update_IMG', true);
//     }
//   };

//   const removeImage = () => {
//     setImagePreview(null);
//     formik.setFieldValue('Person_Img', '');
//     formik.setFieldValue('Is_Update_IMG', false);
//   };

//   const formatDateForInput = dateString => {
//     if (!dateString) return '';
//     return dateString.split('T')[0];
//   };

//   // التحقق من صحة IBAN
//   const validateIBAN = value => {
//     if (!value) return true;
//     return value.toUpperCase().startsWith('SA');
//   };

//   // تنسيق IBAN تلقائياً
//   const formatIBAN = value => {
//     if (!value) return value;

//     // إزالة المسافات وتحويل إلى أحرف كبيرة
//     let formatted = value.replace(/\s/g, '').toUpperCase();

//     // إضافة بادئة SA إذا لم تكن موجودة
//     if (!formatted.startsWith('SA')) {
//       formatted = 'SA' + formatted;
//     }

//     // إضافة مسافات كل 4 أحرف للقراءة
//     return formatted.replace(/(.{4})/g, '$1 ').trim();
//   };

//   const handleIBANChange = e => {
//     const formatted = formatIBAN(e.target.value);
//     formik.setFieldValue('IBan', formatted);
//   };

//   // حساب العمر من تاريخ الميلاد
//   const calculateAge = birthDate => {
//     if (!birthDate) return null;
//     const today = new Date();
//     const birth = new Date(birthDate);
//     let age = today.getFullYear() - birth.getFullYear();
//     const monthDiff = today.getMonth() - birth.getMonth();

//     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
//       age--;
//     }

//     return age;
//   };

//   const age = calculateAge(formik.values.DATE_OF_BIRTH);

//   return (
//     <>
//       <div className='row'>
//         <div className='col-xl-9'>
//           {/* البطاقة الأساسية */}
//           <Card className='card shadow-sm mb-4'>
//             <CardHeader className=' bg-theme text-white'>
//               <h5 className='mb-0'>
//                 <i className='fa fa-user me-2'></i>
//                 {t('PersonalInformation')}
//               </h5>
//             </CardHeader>
//             <CardBody>
//               <div className='row'>
//                 {/* رقم الموظف */}
//                 <div className='col-md-2'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='fw-bold text-theme'>{t('EmployeeNumber')}</Form.Label>
//                     <Form.Control
//                       readOnly
//                       className='form-control  border-secondary'
//                       value={formik.values.employeeNumber || ''}
//                     />
//                     <Form.Text className='text-muted small'>{t('EmployeeNumberHelp')}</Form.Text>
//                   </Form.Group>
//                 </div>

//                 {/* العنوان */}
//                 <div className='col-md-2'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('title')}</Form.Label>
//                     <Form.Select
//                       className={`form-select ${formik.touched.TITLE && formik.errors.TITLE ? 'is-invalid' : ''}`}
//                       name='TITLE'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.TITLE || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر العنوان' : 'Choose Title'}</option>
//                       {titleOptions.map(list => (
//                         <option key={list.lookupCode} value={list.lookupCode}>
//                           {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {formik.touched.TITLE && formik.errors.TITLE && (
//                       <div className='invalid-feedback d-block'>{formik.errors.TITLE}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* الاسم المحلي */}
//                 <div className='col-md-4'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('LocalName')}</Form.Label>
//                     <Form.Control
//                       type='text'
//                       className={`form-control ${formik.touched.NAME2 && formik.errors.NAME2 ? 'is-invalid' : ''}`}
//                       name='NAME2'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.NAME2 || ''}
//                       placeholder={i18n.language === 'ar' ? 'أدخل الاسم باللغة العربية' : 'Enter name in Arabic'}
//                     />
//                     {formik.touched.NAME2 && formik.errors.NAME2 && (
//                       <div className='invalid-feedback d-block'>{formik.errors.NAME2}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* الاسم العالمي */}
//                 <div className='col-md-4'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('GlobalName')}</Form.Label>
//                     <Form.Control
//                       style={{ direction: 'ltr' }}
//                       type='text'
//                       className={`form-control ${formik.touched.NAME && formik.errors.NAME ? 'is-invalid' : ''}`}
//                       name='NAME'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.NAME || ''}
//                       placeholder='Enter name in English'
//                     />
//                     {formik.touched.NAME && formik.errors.NAME && (
//                       <div className='invalid-feedback d-block'>{formik.errors.NAME}</div>
//                     )}
//                   </Form.Group>
//                 </div>
//               </div>

//               <div className='row'>
//                 {/* الجنس */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('Gender')}</Form.Label>
//                     <Form.Select
//                       className={`form-select ${formik.touched.GENDER && formik.errors.GENDER ? 'is-invalid' : ''}`}
//                       name='GENDER'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.GENDER || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر الجنس' : 'Choose Gender'}</option>
//                       {genderOptions.map(list => (
//                         <option key={list.lookupCode} value={list.lookupCode}>
//                           {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {formik.touched.GENDER && formik.errors.GENDER && (
//                       <div className='invalid-feedback d-block'>{formik.errors.GENDER}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* الهوية الوطنية */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('Identity')}</Form.Label>
//                     <Form.Control
//                       type='text'
//                       className={`form-control ${
//                         formik.touched.NATIONAL_IDENTIFIER && formik.errors.NATIONAL_IDENTIFIER ? 'is-invalid' : ''
//                       }`}
//                       name='NATIONAL_IDENTIFIER'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.NATIONAL_IDENTIFIER || ''}
//                       placeholder={i18n.language === 'ar' ? '١٠٠٠٠٠٠٠٠٠' : '1000000000'}
//                       maxLength='10'
//                     />
//                     {formik.touched.NATIONAL_IDENTIFIER && formik.errors.NATIONAL_IDENTIFIER && (
//                       <div className='invalid-feedback d-block'>{formik.errors.NATIONAL_IDENTIFIER}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* البريد الإلكتروني */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('Email')}</Form.Label>
//                     <Form.Control
//                       type='email'
//                       className={`form-control ${
//                         formik.touched.emailAddress && formik.errors.emailAddress ? 'is-invalid' : ''
//                       }`}
//                       name='emailAddress'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.emailAddress || ''}
//                       placeholder='employee@company.com'
//                     />
//                     {formik.touched.emailAddress && formik.errors.emailAddress && (
//                       <div className='invalid-feedback d-block'>{formik.errors.emailAddress}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* رقم الجوال */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('MobileNumber')}</Form.Label>
//                     <div className='input-group'>
//                       <span className='input-group-text'>+966</span>
//                       <Form.Control
//                         type='tel'
//                         className={`form-control ${formik.touched.mobile && formik.errors.mobile ? 'is-invalid' : ''}`}
//                         name='mobile'
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                         value={formik.values.mobile || ''}
//                         placeholder='5XXXXXXX'
//                         maxLength='9'
//                       />
//                     </div>
//                     {formik.touched.mobile && formik.errors.mobile && (
//                       <div className='invalid-feedback d-block'>{formik.errors.mobile}</div>
//                     )}
//                   </Form.Group>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>

//           {/* بطاقة المعلومات الشخصية الإضافية */}
//           <div className='card border-0 shadow-sm mb-4'>
//             <div className='card-header '>
//               <h6 className='mb-0 text-dark'>
//                 <i className='fa fa-id-card me-2'></i>
//                 {t('AdditionalPersonalInfo')}
//               </h6>
//             </div>
//             <div className='card-body'>
//               <div className='row'>
//                 {/* الحالة الاجتماعية */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>{t('Marital Status')}</Form.Label>
//                     <Form.Select
//                       className={`form-select ${
//                         formik.touched.MARITAL_STATUS && formik.errors.MARITAL_STATUS ? 'is-invalid' : ''
//                       }`}
//                       name='MARITAL_STATUS'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.MARITAL_STATUS || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر الحالة' : 'Choose Status'}</option>
//                       {maritalOptions.map(list => (
//                         <option key={list.lookupCode} value={list.lookupCode}>
//                           {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {formik.touched.MARITAL_STATUS && formik.errors.MARITAL_STATUS && (
//                       <div className='invalid-feedback d-block'>{formik.errors.MARITAL_STATUS}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* الديانة */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>{t('Religion')}</Form.Label>
//                     <Form.Select
//                       className={`form-select ${formik.touched.Religion && formik.errors.Religion ? 'is-invalid' : ''}`}
//                       name='Religion'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.Religion || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر الديانة' : 'Choose Religion'}</option>
//                       {religionOptions.map(list => (
//                         <option key={list.lookupCode} value={list.lookupCode}>
//                           {i18n.language === 'ar' ? list.meaning2 : list.meaning}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {formik.touched.Religion && formik.errors.Religion && (
//                       <div className='invalid-feedback d-block'>{formik.errors.Religion}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* الجنسية */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('Nationality')}</Form.Label>
//                     <Select
//                       classNamePrefix='react-select'
//                       isRtl={i18n.language === 'ar'}
//                       isSearchable={true}
//                       options={dataNATIONALITY}
//                       onChange={option => formik.setFieldValue('NATIONALITY', option.value)}
//                       onBlur={() => formik.setFieldTouched('NATIONALITY', true)}
//                       value={dataNATIONALITY?.find(f => f?.value === formik?.values?.NATIONALITY)}
//                       placeholder={i18n.language === 'ar' ? 'إختر الجنسية' : 'Choose Nationality'}
//                       styles={{
//                         control: base => ({
//                           ...base,
//                           borderColor: formik.touched.NATIONALITY && formik.errors.NATIONALITY ? '#dc3545' : '#dee2e6',
//                           '&:hover': {
//                             borderColor: formik.touched.NATIONALITY && formik.errors.NATIONALITY ? '#dc3545' : '#86b7fe'
//                           }
//                         })
//                       }}
//                     />
//                     {formik.touched.NATIONALITY && formik.errors.NATIONALITY && (
//                       <div className='invalid-feedback d-block'>{formik.errors.NATIONALITY}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* تاريخ التعيين */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('HiringDate')}</Form.Label>
//                     <Form.Control
//                       type='date'
//                       className={`form-control ${
//                         formik.touched.START_DATE && formik.errors.START_DATE ? 'is-invalid' : ''
//                       }`}
//                       name='START_DATE'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formatDateForInput(formik.values.START_DATE)}
//                       max={new Date().toISOString().split('T')[0]}
//                     />
//                     {formik.touched.START_DATE && formik.errors.START_DATE && (
//                       <div className='invalid-feedback d-block'>{formik.errors.START_DATE}</div>
//                     )}
//                   </Form.Group>
//                 </div>
//               </div>

//               <div className='row'>
//                 {/* تاريخ الميلاد */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label className='required'>{t('DateofBirth')}</Form.Label>
//                     <Form.Control
//                       type='date'
//                       className={`form-control ${
//                         formik.touched.DATE_OF_BIRTH && formik.errors.DATE_OF_BIRTH ? 'is-invalid' : ''
//                       }`}
//                       name='DATE_OF_BIRTH'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formatDateForInput(formik.values.DATE_OF_BIRTH)}
//                       max={new Date().toISOString().split('T')[0]}
//                     />
//                     {formik.touched.DATE_OF_BIRTH && formik.errors.DATE_OF_BIRTH && (
//                       <div className='invalid-feedback d-block'>{formik.errors.DATE_OF_BIRTH}</div>
//                     )}
//                     {age !== null && (
//                       <Form.Text className='text-info'>
//                         <i className='fa fa-birthday-cake me-1'></i>
//                         {t('Age')}: {age} {t('Years')}
//                       </Form.Text>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* بلد الميلاد */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>{t('BirthCountry')}</Form.Label>
//                     <Select
//                       classNamePrefix='react-select'
//                       isRtl={i18n.language === 'ar'}
//                       isSearchable={true}
//                       options={dataNATIONALITY}
//                       onChange={option => formik.setFieldValue('COUNTRY_OF_BIRTH', option.value)}
//                       onBlur={() => formik.setFieldTouched('COUNTRY_OF_BIRTH', true)}
//                       value={dataNATIONALITY?.find(f => f.value === formik.values.COUNTRY_OF_BIRTH)}
//                       placeholder={i18n.language === 'ar' ? 'إختر البلد' : 'Choose Country'}
//                     />
//                   </Form.Group>
//                 </div>

//                 {/* مدينة الميلاد */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>{t('CityOfbirth')}</Form.Label>
//                     <Form.Control
//                       type='text'
//                       className={`form-control ${
//                         formik.touched.TOWN_OF_BIRTH && formik.errors.TOWN_OF_BIRTH ? 'is-invalid' : ''
//                       }`}
//                       name='TOWN_OF_BIRTH'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.TOWN_OF_BIRTH || ''}
//                       placeholder={i18n.language === 'ar' ? 'مدينة الميلاد' : 'Birth City'}
//                     />
//                     {formik.touched.TOWN_OF_BIRTH && formik.errors.TOWN_OF_BIRTH && (
//                       <div className='invalid-feedback d-block'>{formik.errors.TOWN_OF_BIRTH}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* الإجازة السنوية */}
//                 <div className='col-md-3'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>{t('AnnualLeave')}</Form.Label>
//                     <Form.Select
//                       className={`form-select ${
//                         formik.touched.AnnualLeave && formik.errors.AnnualLeave ? 'is-invalid' : ''
//                       }`}
//                       name='AnnualLeave'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.AnnualLeave || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر المدة' : 'Choose Duration'}</option>
//                       <option value='21'>21 {t('Days')}</option>
//                       <option value='30'>30 {t('Days')}</option>
//                     </Form.Select>
//                     {formik.touched.AnnualLeave && formik.errors.AnnualLeave && (
//                       <div className='invalid-feedback d-block'>{formik.errors.AnnualLeave}</div>
//                     )}
//                   </Form.Group>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* بطاقة المعلومات المالية */}
//           <div className='card border-0 shadow-sm'>
//             <div className='card-header '>
//               <h6 className='mb-0 text-dark'>
//                 <i className='fa fa-credit-card me-2'></i>
//                 {t('FinancialInformation')}
//               </h6>
//             </div>
//             <div className='card-body'>
//               <div className='row'>
//                 {/* خطة التناوب */}
//                 <div className='col-md-4'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>{t('RotationPlan')}</Form.Label>
//                     <Form.Select
//                       className={`form-select ${
//                         formik.touched.RotationPlanId && formik.errors.RotationPlanId ? 'is-invalid' : ''
//                       }`}
//                       name='RotationPlanId'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.RotationPlanId || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر الخطة' : 'Choose Plan'}</option>
//                       {RotationPlanList?.map(item => (
//                         <option key={item.id} value={item.id}>
//                           {i18n.language === 'ar' ? item.name2 : item.name}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {formik.touched.RotationPlanId && formik.errors.RotationPlanId && (
//                       <div className='invalid-feedback d-block'>{formik.errors.RotationPlanId}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* البنك */}
//                 <div className='col-md-4'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>{t('NameOfTheBank')}</Form.Label>
//                     <Form.Select
//                       className={`form-select ${formik.touched.BankId && formik.errors.BankId ? 'is-invalid' : ''}`}
//                       name='BankId'
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       value={formik.values.BankId || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر البنك' : 'Choose Bank'}</option>
//                       {Banks?.map(item => (
//                         <option key={item.id} value={item.id}>
//                           {i18n.language === 'ar' ? item.name2 : item.name}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {formik.touched.BankId && formik.errors.BankId && (
//                       <div className='invalid-feedback d-block'>{formik.errors.BankId}</div>
//                     )}
//                   </Form.Group>
//                 </div>

//                 {/* IBAN */}
//                 <div className='col-md-4'>
//                   <Form.Group className='mb-3'>
//                     <Form.Label>IBAN</Form.Label>
//                     <div className='input-group'>
//                       <span className='input-group-text  border-end-0'>
//                         <i className='fa fa-university text-muted'></i>
//                       </span>
//                       <Form.Control
//                         type='text'
//                         style={{ direction: 'ltr' }}
//                         className={`form-control border-start-0 ${
//                           formik.touched.IBan && formik.errors.IBan ? 'is-invalid' : ''
//                         }`}
//                         name='IBan'
//                         onChange={handleIBANChange}
//                         onBlur={formik.handleBlur}
//                         value={formik.values.IBan || ''}
//                         placeholder='SA00 0000 0000 0000 0000 0000'
//                         maxLength='34'
//                       />
//                     </div>
//                     {formik.touched.IBan && formik.errors.IBan && (
//                       <div className='invalid-feedback d-block'>{formik.errors.IBan}</div>
//                     )}
//                     {formik.values.IBan && !validateIBAN(formik.values.IBan) && (
//                       <Form.Text className='text-warning'>
//                         <i className='fa fa-exclamation-triangle me-1'></i>
//                         {t('IBANFormatWarning')}
//                       </Form.Text>
//                     )}
//                   </Form.Group>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* الشريط الجانبي للصورة */}
//         <div className='col-xl-3'>
//           <div className='sticky-top' style={{ top: '20px' }}>
//             <div className='card border-0 shadow-sm'>
//               <div className='card-header bg-theme text-white'>
//                 <h6 className='mb-0'>
//                   <i className='fa fa-camera me-2'></i>
//                   {t('ProfilePicture')}
//                 </h6>
//               </div>
//               <div className='card-body text-center'>
//                 {/* معاينة الصورة */}
//                 <div className='mb-3'>
//                   {imagePreview || formik.values.Person_Img ? (
//                     <div className='position-relative'>
//                       <PersonImage
//                         file={imagePreview || formik.values.Person_Img}
//                         className='rounded-circle shadow border border-3 border-theme'
//                         style={{ width: '150px', height: '150px', objectFit: 'cover' }}
//                       />
//                       <button
//                         type='button'
//                         className='btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle'
//                         style={{ width: '30px', height: '30px' }}
//                         onClick={removeImage}
//                         title={t('RemoveImage')}
//                       >
//                         <i className='fa fa-times'></i>
//                       </button>
//                     </div>
//                   ) : (
//                     <div
//                       className=' rounded-circle d-flex align-items-center justify-content-center mx-auto'
//                       style={{ width: '150px', height: '150px' }}
//                     >
//                       <i className='fa fa-user fa-3x text-muted'></i>
//                     </div>
//                   )}
//                 </div>

//                 {/* زر تحميل الصورة */}
//                 <Form.Group>
//                   <Form.Label className='btn btn-outline-theme btn-sm w-100 mb-2'>
//                     <i className='fa fa-upload me-2'></i>
//                     {t('ChoosePhoto')}
//                     <Form.Control
//                       type='file'
//                       className='d-none'
//                       name='Person_Img'
//                       accept='image/jpeg,image/png,image/jpg'
//                       onChange={handleImageUpload}
//                     />
//                   </Form.Label>
//                   <Form.Text className='d-block text-muted small'>
//                     <i className='fa fa-info-circle me-1'></i>
//                     {t('ImageRequirements')}
//                   </Form.Text>
//                 </Form.Group>

//                 {/* معلومات سريعة */}
//                 <div className='mt-4 p-3  rounded'>
//                   <h6 className='text-theme mb-3'>
//                     <i className='fa fa-lightbulb me-2'></i>
//                     {t('QuickTips')}
//                   </h6>
//                   <ul className='list-unstyled small text-start'>
//                     <li className='mb-2'>
//                       <i className='fa fa-asterisk text-danger me-2'></i>
//                       {t('RequiredFieldsNote')}
//                     </li>
//                     <li className='mb-2'>
//                       <i className='fa fa-save text-theme me-2'></i>
//                       {t('SaveOftenTip')}
//                     </li>
//                     <li>
//                       <i className='fa fa-check text-success me-2'></i>
//                       {t('VerifyDataTip')}
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

const EditEmployees = ({ formik }) => {
  const { t, i18n } = useTranslation();
  const { TITLE } = useLookupTitle();
  const { SEX } = useLookupSex();
  const { MAR_STATUS } = useLookupMarStatus();
  const { dataNATIONALITY } = useLookupNationality();
  const { Banks } = useGetBanks();
  const { RotationPlanList } = useGetRotationPlan();
  const { RELIGIONS } = useLookupReligions();

  const [imagePreview, setImagePreview] = useState(null);

  // تحسين الأداء باستخدام useMemo
  const titleOptions = useMemo(() => TITLE?.flatMap(item => item.list || []) || [], [TITLE]);
  const genderOptions = useMemo(() => SEX?.flatMap(item => item.list || []) || [], [SEX]);
  const maritalOptions = useMemo(() => MAR_STATUS?.flatMap(item => item.list || []) || [], [MAR_STATUS]);
  const religionOptions = useMemo(() => RELIGIONS?.flatMap(item => item.list || []) || [], [RELIGIONS]);

  const handleImageUpload = event => {
    const file = event.currentTarget.files[0];
    if (file) {
      // التحقق من حجم الصورة
      if (file.size > 1 * 1024 * 1024) {
        alert(t('ImageSizeError'));
        event.target.value = '';
        return;
      }

      // التحقق من نوع الملف
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        alert(t('ImageTypeError'));
        event.target.value = '';
        return;
      }

      // إنشاء معاينة للصورة
      const reader = new FileReader();
      reader.onload = e => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);

      formik.setFieldValue('Person_Img', file);
      formik.setFieldValue('Is_Update_IMG', true);
    }
  };

  const removeImage = () => {
    setImagePreview(null);
    formik.setFieldValue('Person_Img', '');
    formik.setFieldValue('Is_Update_IMG', false);
  };

  const formatDateForInput = dateString => {
    if (!dateString) return '';
    return dateString.split('T')[0];
  };

  // التحقق من صحة IBAN
  const validateIBAN = value => {
    if (!value) return true;
    return value.toUpperCase().startsWith('SA');
  };

  // تنسيق IBAN تلقائياً
  const formatIBAN = value => {
    if (!value) return value;

    // إزالة المسافات وتحويل إلى أحرف كبيرة
    let formatted = value.replace(/\s/g, '').toUpperCase();

    // إضافة بادئة SA إذا لم تكن موجودة
    if (!formatted.startsWith('SA')) {
      formatted = 'SA' + formatted;
    }

    // إضافة مسافات كل 4 أحرف للقراءة
    return formatted.replace(/(.{4})/g, '$1 ').trim();
  };

  const handleIBANChange = e => {
    const formatted = formatIBAN(e.target.value);
    formik.setFieldValue('IBan', formatted);
  };

  // حساب العمر من تاريخ الميلاد
  const calculateAge = birthDate => {
    if (!birthDate) return null;
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }

    return age;
  };

  const age = calculateAge(formik.values.DATE_OF_BIRTH);

  return (
    <>
      {/* شريط التقدم */}

      <div className='row'>
        <div className='col-xl-9'>
          {/* البطاقة الأساسية - المعلومات الشخصية */}
          <Card className='shadow-sm mb-4'>
            <CardHeader className='bg-theme bg-opacity-50 text-white'>
              <div className='d-flex align-items-center'>
                <i className='fa fa-user fa-lg me-2'></i>
                <h5 className='mb-0'>{t('PersonalInformation')}</h5>
              </div>
            </CardHeader>
            <CardBody>
              <div className='row'>
                {/* رقم الموظف */}
                <div className='col-md-2'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='fw-bold text-theme'>{t('EmployeeNumber')}</Form.Label>
                    <Form.Control
                      readOnly
                      className='form-control  border-secondary'
                      value={formik.values.employeeNumber || ''}
                    />
                    <Form.Text className='text-muted small'>
                      <i className='fa fa-info-circle me-1'></i>
                      {t('EmployeeNumberHelp')}
                    </Form.Text>
                  </Form.Group>
                </div>

                {/* العنوان */}
                <div className='col-md-2'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('title')}</Form.Label>
                    <Form.Select
                      className={`form-select ${formik.touched.TITLE && formik.errors.TITLE ? 'is-invalid' : ''}`}
                      name='TITLE'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.TITLE || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر اللقب' : 'Choose Title'}</option>
                      {titleOptions.map(list => (
                        <option key={list.lookupCode} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.touched.TITLE && formik.errors.TITLE && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.TITLE}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* الاسم المحلي */}
                <div className='col-md-4'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('LocalName')}</Form.Label>
                    <Form.Control
                      type='text'
                      className={`form-control ${formik.touched.NAME2 && formik.errors.NAME2 ? 'is-invalid' : ''}`}
                      name='NAME2'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.NAME2 || ''}
                      placeholder={i18n.language === 'ar' ? 'أدخل الاسم باللغة العربية' : 'Enter name in Arabic'}
                    />
                    {formik.touched.NAME2 && formik.errors.NAME2 && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.NAME2}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* الاسم العالمي */}
                <div className='col-md-4'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('GlobalName')}</Form.Label>
                    <Form.Control
                      style={{ direction: 'ltr' }}
                      type='text'
                      className={`form-control ${formik.touched.NAME && formik.errors.NAME ? 'is-invalid' : ''}`}
                      name='NAME'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.NAME || ''}
                      placeholder='Enter name in English'
                    />
                    {formik.touched.NAME && formik.errors.NAME && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.NAME}
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className='row'>
                {/* الجنس */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('Gender')}</Form.Label>
                    <Form.Select
                      className={`form-select ${formik.touched.GENDER && formik.errors.GENDER ? 'is-invalid' : ''}`}
                      name='GENDER'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.GENDER || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر الجنس' : 'Choose Gender'}</option>
                      {genderOptions.map(list => (
                        <option key={list.lookupCode} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.touched.GENDER && formik.errors.GENDER && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.GENDER}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* الهوية الوطنية */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('Identity')}</Form.Label>
                    <Form.Control
                      type='text'
                      className={`form-control ${
                        formik.touched.NATIONAL_IDENTIFIER && formik.errors.NATIONAL_IDENTIFIER ? 'is-invalid' : ''
                      }`}
                      name='NATIONAL_IDENTIFIER'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.NATIONAL_IDENTIFIER || ''}
                      placeholder={'1000000000'}
                      maxLength='10'
                    />
                    {formik.touched.NATIONAL_IDENTIFIER && formik.errors.NATIONAL_IDENTIFIER && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.NATIONAL_IDENTIFIER}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* البريد الإلكتروني */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('Email')}</Form.Label>
                    <Form.Control
                      type='email'
                      className={`form-control ${
                        formik.touched.emailAddress && formik.errors.emailAddress ? 'is-invalid' : ''
                      }`}
                      name='emailAddress'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.emailAddress || ''}
                      placeholder='employee@company.com'
                    />
                    {formik.touched.emailAddress && formik.errors.emailAddress && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.emailAddress}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* رقم الجوال */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('MobileNumber')}</Form.Label>
                    <div className='input-group'>
                      <span className='input-group-text '>
                        <i className='fa fa-phone text-muted'></i>
                      </span>
                      <Form.Control
                        type='tel'
                        className={`form-control ${formik.touched.mobile && formik.errors.mobile ? 'is-invalid' : ''}`}
                        name='mobile'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.mobile || ''}
                        placeholder='966xxxxxxxxx'
                        // maxLength='9'
                      />
                    </div>
                    {formik.touched.mobile && formik.errors.mobile && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.mobile}
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>
            </CardBody>
          </Card>

          {/* بطاقة المعلومات الشخصية الإضافية */}
          <Card className='shadow-sm mb-4'>
            <CardHeader className='bg-secondary bg-opacity-50'>
              <div className='d-flex align-items-center'>
                <i className='fa fa-id-card text-theme me-2'></i>
                <h6 className='mb-0  '>{t('AdditionalPersonalInfo')}</h6>
              </div>
            </CardHeader>
            <CardBody>
              <div className='row'>
                {/* الحالة الاجتماعية */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Marital Status')}</Form.Label>
                    <Form.Select
                      className={`form-select ${
                        formik.touched.MARITAL_STATUS && formik.errors.MARITAL_STATUS ? 'is-invalid' : ''
                      }`}
                      name='MARITAL_STATUS'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.MARITAL_STATUS || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر الحالة' : 'Choose Status'}</option>
                      {maritalOptions.map(list => (
                        <option key={list.lookupCode} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.touched.MARITAL_STATUS && formik.errors.MARITAL_STATUS && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.MARITAL_STATUS}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* الديانة */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Religion')}</Form.Label>
                    <Form.Select
                      className={`form-select ${formik.touched.Religion && formik.errors.Religion ? 'is-invalid' : ''}`}
                      name='Religion'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.Religion || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر الديانة' : 'Choose Religion'}</option>
                      {religionOptions.map(list => (
                        <option key={list.lookupCode} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.touched.Religion && formik.errors.Religion && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.Religion}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* الجنسية */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('Nationality')}</Form.Label>
                    <Select
                      classNamePrefix='react-select'
                      isRtl={i18n.language === 'ar'}
                      isSearchable={true}
                      options={dataNATIONALITY}
                      onChange={option => formik.setFieldValue('NATIONALITY', option.value)}
                      onBlur={() => formik.setFieldTouched('NATIONALITY', true)}
                      value={dataNATIONALITY?.find(f => f?.value === formik?.values?.NATIONALITY)}
                      placeholder={i18n.language === 'ar' ? 'إختر الجنسية' : 'Choose Nationality'}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                    {formik.touched.NATIONALITY && formik.errors.NATIONALITY && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.NATIONALITY}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* تاريخ التعيين */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('HiringDate')}</Form.Label>
                    <div className='input-group'>
                      <span className='input-group-text '>
                        <i className='fa fa-calendar text-muted'></i>
                      </span>
                      <Form.Control
                        type='date'
                        className={`form-control ${
                          formik.touched.START_DATE && formik.errors.START_DATE ? 'is-invalid' : ''
                        }`}
                        name='START_DATE'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formatDateForInput(formik.values.START_DATE)}
                        max={new Date().toISOString().split('T')[0]}
                      />
                    </div>
                    {formik.touched.START_DATE && formik.errors.START_DATE && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.START_DATE}
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className='row'>
                {/* تاريخ الميلاد */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label className='required'>{t('DateofBirth')}</Form.Label>
                    <div className='input-group'>
                      <span className='input-group-text '>
                        <i className='fa fa-birthday-cake text-muted'></i>
                      </span>
                      <Form.Control
                        type='date'
                        className={`form-control ${
                          formik.touched.DATE_OF_BIRTH && formik.errors.DATE_OF_BIRTH ? 'is-invalid' : ''
                        }`}
                        name='DATE_OF_BIRTH'
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formatDateForInput(formik.values.DATE_OF_BIRTH)}
                        max={new Date().toISOString().split('T')[0]}
                      />
                    </div>
                    {formik.touched.DATE_OF_BIRTH && formik.errors.DATE_OF_BIRTH && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.DATE_OF_BIRTH}
                      </div>
                    )}
                    {age !== null && (
                      <Form.Text className='text-info d-block mt-1'>
                        <i className='fa fa-info-circle me-1'></i>
                        {t('Age')}: <strong>{age}</strong> {t('Years')}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                {/* بلد الميلاد */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('BirthCountry')}</Form.Label>
                    <Select
                      classNamePrefix='react-select'
                      isRtl={i18n.language === 'ar'}
                      isSearchable={true}
                      options={dataNATIONALITY}
                      onChange={option => formik.setFieldValue('COUNTRY_OF_BIRTH', option.value)}
                      onBlur={() => formik.setFieldTouched('COUNTRY_OF_BIRTH', true)}
                      value={dataNATIONALITY?.find(f => f.value === formik.values.COUNTRY_OF_BIRTH)}
                      placeholder={i18n.language === 'ar' ? 'إختر البلد' : 'Choose Country'}
                        menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </Form.Group>
                </div>

                {/* مدينة الميلاد */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('CityOfbirth')}</Form.Label>
                    <Form.Control
                      type='text'
                      className={`form-control ${
                        formik.touched.TOWN_OF_BIRTH && formik.errors.TOWN_OF_BIRTH ? 'is-invalid' : ''
                      }`}
                      name='TOWN_OF_BIRTH'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.TOWN_OF_BIRTH || ''}
                      placeholder={i18n.language === 'ar' ? 'مدينة الميلاد' : 'Birth City'}
                    />
                    {formik.touched.TOWN_OF_BIRTH && formik.errors.TOWN_OF_BIRTH && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.TOWN_OF_BIRTH}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* الإجازة السنوية */}
                <div className='col-md-3'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('AnnualLeave')}</Form.Label>
                    <Form.Select
                      className={`form-select ${
                        formik.touched.AnnualLeave && formik.errors.AnnualLeave ? 'is-invalid' : ''
                      }`}
                      name='AnnualLeave'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.AnnualLeave || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر المدة' : 'Choose Duration'}</option>
                      <option value='21'>21 {t('Days')}</option>
                      <option value='30'>30 {t('Days')}</option>
                    </Form.Select>
                    {formik.touched.AnnualLeave && formik.errors.AnnualLeave && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.AnnualLeave}
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>
            </CardBody>
          </Card>

          {/* بطاقة المعلومات المالية */}
          <Card className='shadow-sm'>
            <CardHeader className='bg-secondary bg-opacity-50'>
              <div className='d-flex align-items-center'>
                <i className='fa fa-credit-card text-theme me-2'></i>
                <h6 className='mb-0  '>{t('FinancialInformation')}</h6>
              </div>
            </CardHeader>
            <CardBody>
              <div className='row'>
                {/* خطة التناوب */}
                <div className='col-md-4'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('RotationPlan')}</Form.Label>
                    <Form.Select
                      className={`form-select ${
                        formik.touched.RotationPlanId && formik.errors.RotationPlanId ? 'is-invalid' : ''
                      }`}
                      name='RotationPlanId'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.RotationPlanId || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر الخطة' : 'Choose Plan'}</option>
                      {RotationPlanList?.map(item => (
                        <option key={item.id} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.touched.RotationPlanId && formik.errors.RotationPlanId && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.RotationPlanId}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* البنك */}
                <div className='col-md-4'>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('NameOfTheBank')}</Form.Label>
                    <Form.Select
                      className={`form-select ${formik.touched.BankId && formik.errors.BankId ? 'is-invalid' : ''}`}
                      name='BankId'
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.BankId || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر البنك' : 'Choose Bank'}</option>
                      {Banks?.map(item => (
                        <option key={item.id} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                    {formik.touched.BankId && formik.errors.BankId && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.BankId}
                      </div>
                    )}
                  </Form.Group>
                </div>

                {/* IBAN */}
                <div className='col-md-4'>
                  <Form.Group className='mb-3'>
                    <Form.Label>IBAN</Form.Label>
                    <div className='input-group'>
                      <span className='input-group-text  border-end-0'>
                        <i className='fa fa-university text-muted'></i>
                      </span>
                      <Form.Control
                        type='text'
                        style={{ direction: 'ltr' }}
                        className={`form-control border-start-0 ${
                          formik.touched.IBan && formik.errors.IBan ? 'is-invalid' : ''
                        }`}
                        name='IBan'
                        onChange={handleIBANChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.IBan || ''}
                        placeholder='SA00 0000 0000 0000 0000 0000'
                        maxLength='34'
                      />
                    </div>
                    {formik.touched.IBan && formik.errors.IBan && (
                      <div className='invalid-feedback d-block'>
                        <i className='fa fa-exclamation-circle me-1'></i>
                        {formik.errors.IBan}
                      </div>
                    )}
                    {formik.values.IBan && !validateIBAN(formik.values.IBan) && (
                      <Form.Text className='text-warning d-block mt-1'>
                        <i className='fa fa-exclamation-triangle me-1'></i>
                        {t('IBANFormatWarning')}
                      </Form.Text>
                    )}
                    {formik.values.IBan && validateIBAN(formik.values.IBan) && (
                      <Form.Text className='text-success d-block mt-1'>
                        <i className='fa fa-check-circle me-1'></i>
                        {t('IBANFormatValid')}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* الشريط الجانبي للصورة */}
        <div className='col-xl-3'>
          <div className='sticky-top' style={{ top: '100px' }}>
            <Card className='shadow-sm'>
              <CardHeader className='bg-theme bg-opacity-50 text-white '>
                <div className='d-flex align-items-center'>
                  <i className='fa fa-camera me-2'></i>
                  <h6 className='mb-0'>{t('ProfilePicture')}</h6>
                </div>
              </CardHeader>
              <CardBody className='text-center'>
                {/* معاينة الصورة */}
                <div className='mb-3'>
                  {imagePreview || formik.values.Person_Img ? (
                    <div className='position-relative d-inline-block'>
                      <PersonImage
                        file={imagePreview || formik.values.Person_Img}
                        className='rounded-circle shadow border border-3 border-theme'
                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                      />
                      <button
                        type='button'
                        className='btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle'
                        style={{ width: '30px', height: '30px' }}
                        onClick={removeImage}
                        title={t('RemoveImage')}
                      >
                        <i className='fa fa-times'></i>
                      </button>
                    </div>
                  ) : (
                    <div
                      className=' rounded-circle d-flex align-items-center justify-content-center mx-auto'
                      style={{ width: '150px', height: '150px' }}
                    >
                      <i className='fa fa-user fa-3x text-muted'></i>
                    </div>
                  )}
                </div>

                {/* زر تحميل الصورة */}
                <Form.Group>
                  <Form.Label className='btn btn-outline-theme btn-sm w-100 mb-2 cursor-pointer'>
                    <i className='fa fa-upload me-2'></i>
                    {t('ChoosePhoto')}
                    <Form.Control
                      type='file'
                      className='d-none'
                      name='Person_Img'
                      accept='image/jpeg,image/png,image/jpg'
                      onChange={handleImageUpload}
                    />
                  </Form.Label>
                  <Form.Text className='d-block text-muted small'>
                    <i className='fa fa-info-circle me-1'></i>
                    {t('ImageRequirements')}
                  </Form.Text>
                </Form.Group>

                {/* معلومات سريعة */}
                {/* <div className='mt-4 p-3  rounded'>
                  <h6 className='text-theme mb-3'>
                    <i className='fa fa-lightbulb me-2'></i>
                    {t('QuickTips')}
                  </h6>
                  <ul className='list-unstyled small text-start'>
                    <li className='mb-2'>
                      <i className='fa fa-asterisk text-danger me-2'></i>
                      {t('RequiredFieldsNote')}
                    </li>
                    <li className='mb-2'>
                      <i className='fa fa-save text-theme me-2'></i>
                      {t('SaveOftenTip')}
                    </li>
                    <li className='mb-2'>
                      <i className='fa fa-check text-success me-2'></i>
                      {t('VerifyDataTip')}
                    </li>
                    <li>
                      <i className='fa fa-refresh text-info me-2'></i>
                      {t('AutoSaveTip')}
                    </li>
                  </ul>
                </div> */}

                {/* ملخص الحقول المطلوبة */}
                {/* <div className='mt-3 p-3 bg-warning bg-opacity-10 rounded'>
                  <h6 className='text-warning mb-2'>
                    <i className='fa fa-exclamation-triangle me-2'></i>
                    {t('RequiredFields')}
                  </h6>
                  <div className='small text-start'>
                    <div className={`mb-1 ${formik.values.TITLE ? 'text-success' : 'text-danger'}`}>• {t('title')}</div>
                    <div className={`mb-1 ${formik.values.NAME2 ? 'text-success' : 'text-danger'}`}>
                      • {t('LocalName')}
                    </div>
                    <div className={`mb-1 ${formik.values.NAME ? 'text-success' : 'text-danger'}`}>
                      • {t('GlobalName')}
                    </div>
                    <div className={`mb-1 ${formik.values.GENDER ? 'text-success' : 'text-danger'}`}>
                      • {t('Gender')}
                    </div>
                    <div className={`mb-1 ${formik.values.NATIONAL_IDENTIFIER ? 'text-success' : 'text-danger'}`}>
                      • {t('Identity')}
                    </div>
                  </div>
                </div> */}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditEmployees;
